<template>
  <card type="default" header-classes="bg-transparent">
    <div slot="header" class="row align-items-center">
      <div class="col">
        <h6 class="text-light text-uppercase ls-1 mb-1">Übersicht</h6>
        <h5 class="h3 text-white mb-0">Abfragen Spielersperrdatei</h5>
      </div>
      <div class="col">
        <!----
        <ul class="nav nav-pills justify-content-end">
          <li class="nav-item mr-2 mr-md-0">
            <a class="nav-link py-2 px-3"
               href="#"
               :class="{active: bigLineChart.activeIndex === 'month'}"
               @click.prevent="initBigChart">
              <span class="d-none d-md-block">letzte 30 Tage</span>
              <span class="d-md-none">M</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link py-2 px-3"
               href="#"
               :class="{active: bigLineChart.activeIndex === 'week'}"
               @click.prevent="initBigChart">
              <span class="d-none d-md-block">7 Tage</span>
              <span class="d-md-none">W</span>
            </a>
          </li>
        </ul> --->
      </div>
    </div>
    <line-chart
        :height="350"
        ref="bigChart"
        :chart-data="bigLineChart.chartData"
        :extra-options="bigLineChart.extraOptions"
    >
    </line-chart>

  </card>
</template>
<script>
import LineChart from '@/components/Charts/LineChart'
import * as chartConfigs from "@/components/Charts/config";
import moment from "moment/moment";

export default {
  name: 'VisitorChart',
  components: {LineChart},
  props: {
    customer: {
      type: Object
    },
    location: {
      type: Object
    },
    from: {
      type: String
    },
    to: {
      type: String
    }
  },
  data() {
    return {
      requests: {
        date: new Date(),
        count: 0
      },
      bigLineChart: {
        allData: [
          [0, 20, 10, 30, 15, 40, 20, 60, 60],
          [0, 20, 5, 25, 10, 30, 15, 40, 40]
        ],
        activeIndex: 'month',
        chartData: {
          datasets: [],
          labels: [],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
    }
  },
  created(){
    this.init()
  },
  watch: {
    location: function () {
      this.init()
    },
    customer: function () {
      this.init()
    },
    from: function () {
      this.init()
    },
    to: function () {
      this.init()
    }
  },
  methods: {
    getData(from, to) {
      return new Promise((resolve, reject) => {
        const header = this.authHeader();
        header['Content-Type'] = 'application/json';
        const requestOptions = {
          method: 'GET',
          headers: header
        };

        let url = process.env.VUE_APP_API_SERVER + `/stats/chart`;
        url = url + `/` + this.customer.id;
        url = url + `/` + this.location.id;
        if (from !== null) url = url + `/` + from;
        if (to !== null) url = url + `/` + to;


        fetch(url, requestOptions)
            .then(this.handleResponse)
            .then(response => {
              resolve(response);
            }, error => {
              reject(error);
            });
      });
    },
    init() {
      this.getData(this.from,this.to).then(
          response => {
            this.requests = response.requests.month
            this.initChart()
          },
          error => {
            if (error.toString().includes('NetworkError when attempting')) {
              this.$store.dispatch('alert/warn', 'Das Laden dauert zu lange. Verkürzen Sie die Zeitspanne oder beschränken Sie die Abfrage auf einen Standort.')
            } else {
              this.$store.dispatch('alert/error', error)
            }
          }
      )
    },
    initChart() {
      let data = this.requests;
      let transdata = [];
      let translabel = [];
      data.forEach(element => {
        transdata.push(element.count);
        translabel.push(moment(element.date,"YYYY-MM-DD").format("dd. D.M."))
      });
      let chartData = {
        datasets: [
          {
            label: 'Spielerabfragen',
            data: transdata
          }
        ],
        labels: translabel,
      };
      this.bigLineChart.chartData = chartData;
    },
  }
}
</script>